import { Tag, Text } from "@asurion-core/mx-asurion-ui-react";
import { DetailsContainer, DetailsWrapperContainer, HighlightText } from "@ubif/components";
import { KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { FlexContactWrapperContainer, FlexNameWrapperContainer } from "./FlexContainers";

type QuicKSearchPartsProps = {
  itemName: string;
  itemNumber: string;
  availableCount: number;
  highlightText: string;
  onClick?: () => void;
};
export const QuickSearchPartsDetails = ({
  itemName,
  itemNumber,
  availableCount,
  highlightText,
  onClick
}: QuicKSearchPartsProps) => {
  const { t } = useTranslation("root-config");

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) return;

    if (event.key === "Enter" || event.key === " " || event.key === "Spacebar") {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <StyledQuickSearchPartsDetails
      onClick={onClick}
      onKeyDown={handleKeyDown}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      $clickable={!!onClick}
    >
      <DetailsContainer>
        <FlexNameWrapperContainer>
          <HighlightText highlightText={highlightText} wholeText={itemName} />
          <HighlightText highlightText={highlightText} wholeText={itemNumber} />
        </FlexNameWrapperContainer>
        <FlexContactWrapperContainer>
          <Text color="#5D5E61">{itemNumber}</Text>
          <Tag
            text={
              availableCount ? `${availableCount} ${t("GlobalSearch.Available")}` : `${t("GlobalSearch.Unavailable")}`
            }
            type={availableCount ? "success" : "warn"}
          />
        </FlexContactWrapperContainer>
      </DetailsContainer>
    </StyledQuickSearchPartsDetails>
  );
};

const StyledQuickSearchPartsDetails = styled(DetailsWrapperContainer)<{ $clickable: boolean }>`
  background-color: var(--aui-elevated-level-01);
  color: var(--aui-on-surface);
  overflow: auto;
  &:hover {
    background-color: var(--aui-outline-soft);
    border-radius: 0.5rem;
    cursor: ${(p) => (p.$clickable ? "pointer" : "default")};
  }
`;
